import { render } from "./LessonHeaderComponent.vue?vue&type=template&id=e9c4849c&scoped=true"
import script from "./LessonHeaderComponent.vue?vue&type=script&lang=js"
export * from "./LessonHeaderComponent.vue?vue&type=script&lang=js"

import "./LessonHeaderComponent.vue?vue&type=style&index=0&id=e9c4849c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9c4849c"]])

export default __exports__